import script from "./NotificationToast.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationToast.vue?vue&type=script&setup=true&lang=js"

import "./NotificationToast.vue?vue&type=style&index=0&id=cb3c245e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb3c245e"]])

export default __exports__